export default {
    insurances: state => {
        return state.insurances;
    },
}
